// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_TOPICS = "Sp\u00e4\u0165 na kateg\u00f3rie";
export const IN_DISCUSSION = "V diskusii";
